/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skill_Groups_Is_Default_TeamInputs */

const en_tables_skill_groups_is_default_team = /** @type {(inputs: Tables_Skill_Groups_Is_Default_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups Is Default Team`)
};

const de_tables_skill_groups_is_default_team = /** @type {(inputs: Tables_Skill_Groups_Is_Default_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Standard Team`)
};

/**
* | output |
* | --- |
* | "Groups Is Default Team" |
*
* @param {Tables_Skill_Groups_Is_Default_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skill_groups_is_default_team = /** @type {((inputs?: Tables_Skill_Groups_Is_Default_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skill_Groups_Is_Default_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skill_groups_is_default_team(inputs)
	return de_tables_skill_groups_is_default_team(inputs)
});